export default __webpack_public_path__ + "static/media/ic_threedots.ae520a27.svg";